import './../vendors/iziModal';
import ContactForm from './contact-form';

class Modals {

    constructor() {
    	if ( $("[modal-speaker]").length ){
			this.init();
		}
    }

    init() {

		document.addEventListener('DOMContentLoaded',()=>{
			this.speakerModal();
		})
    }

    speakerModal(){
		$("[modal-speaker]").iziModal({
			radius: 0,
			overlayColor: 'rgba(0, 125, 195, 0.9)',
			width: 1200,
			// onClosed: () => {
			// 	let responseContainer = document.getElementById('speaker-modal-response');
			// 	if(responseContainer){
			// 		responseContainer.innerHTML = '';
			// 	}
			// }
		});

		$('[speaker]').on('click', function (event) {
			event.preventDefault();
			let speakerId = this.dataset.speaker;
			let modal = document.getElementById(`modal`);
			//let responseContainer = document.getElementById('speaker-modal-response');

			$(modal).iziModal('open');

			// var data = {
			// 	'action': 'get_speaker',
			// 	'id' : speakerId,
			// };
			//
			// $.ajax({
			// 	url:ajaxurl,
			// 	data:data,
			// 	type:'GET',
			// 	success: response => {
			// 		if( response.success && response.data){
			// 			responseContainer.innerHTML = response.data;
			// 			$(modal).iziModal('open');
			// 		}
			// 	}
			// });


		});
	}

}

export default Modals;



// WEBPACK FOOTER //
// ./scripts/modules/modals.js